export default {
  date: 'June 20, 2025',
  title: 'A Developer’s Success Story: How a Real Window View in 360 Tours Increased Sales by 27%',
  description: 'Find out how to create a floor plan with a real window view using only your smartphone — no drones or special equipment needed.',
  id: 'personal-window-view',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        One of our clients — a major real estate developer — had long been publishing listings on property marketplaces with standard 360° tours. These tours allowed potential buyers to "walk through" the apartment, but they couldn’t step out onto the balcony or see the actual view from the window.
        Buyers were left guessing what they’d see in the morning, how the sunlight hits the space, or what kind of atmosphere surrounds the building. This uncertainty delayed decision-making and made the sales team’s job harder.
      </p>
      <p>
        <b>Everything changed with AI Getfloorplan</b>
      </p>
      <p>
        After discovering our AI service, the developer gave the technology a try.<b>AI Getfloorplan is the first AI in the world that can insert a real window view into virtual tours with 100% accuracy — using just a photo taken on a smartphone.</b>
      </p>
      <p>No drones, no professional cameras, no complicated setups — just a few photos from the balcony taken with a regular phone.</p>
      <p>The AI automatically detected the shooting angle and perfectly integrated the view into the tour, preserving:</p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>the exact direction and positioning of the window,</li>
        <li class='margin-none'>lighting and natural ambiance,</li>
        <li class='margin-none'>the geometry and proportions of the apartment.</li>
      </ul>
      <p>The result? Higher-quality leads and happier teams</p>
      <p>After publishing the upgraded tours with real views from the windows:</p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>
          <b>Qualified leads increased by 27%</b> — buyers who reached out already knew what to expect;
        </li>
        <li class='margin-none'>
          <b>Clients were more confident and emotionally engaged,</b> having already experienced the atmosphere outside the window;
        </li>
        <li class='margin-none'>
          <b>The sales team requested ALL tours to include real window views,</b> as it made closing deals faster and easier;
        </li>
        <li class='margin-none'>
          <b>The marketing team was thrilled</b> with the boost in conversion and lead quality.
        </li>
      </ul>
      <p>
        <b>A real view from the window isn’t a luxury — it’s the new standard in real estate sales.</b>
      </p>
      <p>Submit a request, and we’ll add real window views to your 360 tours. All we need is a simple panoramic photo from your smartphone.</p>
      <p>
        <b>AI Getfloorplan</b> — precision, atmosphere, and buyer trust, starting from the very first virtual tour.
      </p>
    </div>
  ),
  thumb: 'news/50.webp',
};
